function checkIc(ic) {
    try {
        var a = 0;
        if (ic.length == 0) return true;
        if (ic.length != 8) throw 1;
        var b = ic.split('');
        var c = 0;
        for (var i = 0; i < 7; i++) a += (parseInt(b[i]) * (8 - i));
        a = a % 11;
        c = 11 - a;
        if (a == 1) c = 0;
        if (a == 0) c = 1;
        if (a == 10) c = 1;
        if (parseInt(b[7]) != c) throw (1);
    } catch (e) {
        return false;
    }
    return true;
}